export default __webpack_public_path__ + "static/media/1213.9b3a785b.png";